import React from 'react';
import clsx from 'clsx';
import { SelectInputStyle } from 'components/Component.style';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';

import { ReactComponent as Exclamation } from 'assert/images/Common/exclamation.svg';
import { useTranslation } from 'react-i18next';

function SelectInput({
  label,
  required,
  errMsg,
  placeholder,
  onChange,
  Options = [],
  disabled,
  value,
  mode,
  ValuebyId,
  className,
  renderValue,
  customOptions,
  props,
}) {
  const { t } = useTranslation();
  const isErr = mode === 'multiple' ? !value.length > 0 : !value;
  return (
    <SelectInputStyle>
      <FormControl
        required={required}
        className={clsx('selectContainer', className)}
      >
        {label && (
          <div className="lebelView">
            <label>
              {label} {required && <span className="requiredSymbol">*</span>}
            </label>
          </div>
        )}
        <Select
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          displayEmpty
          renderValue={renderValue}
          {...props}
          {...(() =>
            mode === 'multiple'
              ? {
                  multiple: true,
                  renderValue: (selected) => (
                    <div className="multiselect-container">
                      {selected.map((value) => (
                        <Chip
                          size="small"
                          key={value}
                          label={
                            Options.find((item) => item.value === value)?.label
                          }
                        />
                      ))}
                    </div>
                  ),
                }
              : {})()}
        >
          {!customOptions
            ? Options.map((data) => {
                return (
                  // <MenuItem className="select-menu-item" key={"option_" + data.value} value={data.value} disabled={data?.disabled}>
                  <MenuItem
                    className="select-menu-item"
                    key={'option_' + data.value}
                    value={ValuebyId ? data.label : data.value}
                    disabled={data?.disabled}
                  >
                    {t(data.label)}
                  </MenuItem>
                );
              })
            : customOptions}
        </Select>
        {Boolean(errMsg && isErr) && (
          <span className="errMsg">
            <Exclamation />
            {errMsg}
          </span>
        )}
      </FormControl>
    </SelectInputStyle>
  );
}

export default SelectInput;
